export default {"src":"/_next/static/media/zen.66aa49bf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};